module.exports = __webpack_public_path__ + "img/edutest.641472ea.png";